<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12>
        <v-toolbar color="indigo" dark>
          <v-toolbar-title>{{ $t('Contacts') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm8 offset-sm2 md4 offset-md0>
                <v-card height="370px">
                  <v-img :src="require('@/assets/tp-building.jpg')" height="200px">
                    <v-layout fill-height justify-center align-center>
                      <v-flex shrink>
                        <v-icon dark class="mr-2">far fa-clock</v-icon>
                        <span class="headline white--text" v-text="$t('Working time')"></span>
                      </v-flex>
                      </v-layout>
                  </v-img>

                  <v-card-text>
                    <v-container>
                      <v-layout row wrap>
                        <v-flex xs12 class="subheading blue--text text--darken-4 text-xs-center"><strong>{{ $t('for all office in the country') }}</strong></v-flex>
                        <v-flex xs12 class="text-xs-center" >{{ $t('mon-fri: 09:00-18:00') }}</v-flex>
                        <v-flex xs12 class="text-xs-center" >{{ $t('sat: 09:00-13:00')     }}</v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm8 offset-sm2 md4 offset-md0>
                <v-card height="370px">
                  <v-img :src="require('@/assets/tp-cup.jpg')" height="200px" >
                    <v-layout fill-height justify-center align-center>
                      <v-flex shrink>
                        <v-icon dark class="mr-2">fa-at</v-icon>
                        <span class="headline white--text" v-text="$t('Contact Emails')"></span>
                      </v-flex>
                    </v-layout>
                  </v-img>

                  <v-card-text>
                    <v-container fill-height class="pa-0">
                      <v-layout row wrap>
                        <template v-for="p in emails">
                        <v-flex xs12 class="text-xs-center pa-0 mt-3">
                          <strong>{{ $t(p.text) }}</strong><br/>
                          <a :href="'mailto:' + p.mail" style="text-decoration: none;">{{ p.mail }}</a>
                        </v-flex>
                        </template>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>


              <v-flex xs12 sm8 offset-sm2 md4 offset-md0>
                <v-card height="370px">
                  <v-img :src="require('@/assets/tp-trucks.jpg')" height="200px">
                    <v-layout fill-height justify-center align-center>
                      <v-flex shrink>
                        <v-icon dark class="mr-2">fa-phone</v-icon>
                        <span class="headline white--text" v-text="$t('Contact Phones')"></span>
                      </v-flex>
                    </v-layout>
                  </v-img>

                  <v-card-text>
                    <v-container fill-height>
                      <v-layout row wrap>
                        <v-flex v-for="p in phones" :key="p.display" xs12 class="title text-xs-center indigo--text text--darken-4"><a :href="p.link" style="text-decoration: none;">{{ p.display }}</a></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <iframe src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d22726.630162451813!2d23.391881915524635!3d42.69252615658945!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sbg!2sbg!4v1539186814925" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      emails : [
        {
          text : 'Request email',
          text : 'Queries and transport request',
          mail : 'orders@transpress.bg'
        },
        {
          text : 'Aftersales email',
          text : 'Information and shipment tracking',
          mail : 'aftersales@transpress.bg'
        }
      ],
      phones : [
        {
          display: '*5015',
          link: 'tel:*5015',
        },
        {
          display: '0700 150 50',
          link : 'tel:+35970015050'
        },
        {
          display: '02 948 0700',
          link : 'tel:+35929480700'
        }
      ]
    };
  }
}
</script>

<style scoped>
</style>